import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Loader2, Play, X } from "lucide-react";

export const SamplePicker = ({ open, onClose, onStartInterview, onUseInAlignment }) => {
  const [samples, setSamples] = useState([]);
  const [sel, setSel] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!open) return;
    api.get("/samples").then(({ data }) => setSamples(data.samples || [])).catch(() => {});
  }, [open]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm p-4" data-testid="sample-picker-modal">
      <div className="w-full max-w-lg rounded-2xl border border-zinc-800 bg-zinc-950 p-6 shadow-2xl">
        <div className="flex items-start justify-between">
          <div>
            <div className="text-[10px] uppercase tracking-[0.28em] text-amber-400 mb-1">Try Intuiterview</div>
            <h3 className="text-lg font-semibold text-zinc-50">Pick a sample role</h3>
            <p className="text-xs text-zinc-500 mt-1">Complete demo: real job description, sample candidate, and the full AI interview engine.</p>
          </div>
          <button onClick={onClose} data-testid="sample-close-btn" className="text-zinc-500 hover:text-zinc-200"><X className="h-4 w-4" /></button>
        </div>
        <div className="mt-4 space-y-2">
          {samples.length === 0 && <div className="text-xs text-zinc-500"><Loader2 className="h-3.5 w-3.5 animate-spin inline mr-1.5" />Loading samples…</div>}
          {samples.map((s) => (
            <button key={s.id} onClick={() => setSel(s.id)} data-testid={`sample-${s.id}`}
              className={`w-full text-left rounded-xl border px-4 py-3 transition-colors ${sel === s.id ? "border-amber-500/60 bg-amber-500/10" : "border-zinc-800 bg-zinc-900/40 hover:border-zinc-700"}`}>
              <div className="text-sm text-zinc-100 font-medium">{s.role} <span className="text-zinc-500">@ {s.company}</span></div>
              <div className="text-xs text-zinc-500 mt-0.5">{s.candidate}, {s.background}</div>
            </button>
          ))}
        </div>
        <div className="flex flex-wrap gap-2 mt-4">
          <button
            onClick={async () => { if (sel) { setBusy(true); await onStartInterview?.(sel); setBusy(false); } }}
            disabled={!sel || busy}
            data-testid="sample-start-interview-btn"
            className="inline-flex items-center gap-2 bg-amber-500 hover:bg-amber-400 text-amber-950 font-semibold rounded-lg px-4 py-2 text-sm disabled:opacity-50">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Play className="h-4 w-4" />} Try a Sample Interview
          </button>
          {onUseInAlignment && (
            <button
              onClick={async () => {
                if (!sel) return;
                setBusy(true);
                try {
                  const { data } = await api.get(`/samples/${sel}`);
                  onUseInAlignment(data);
                  onClose?.();
                } finally { setBusy(false); }
              }}
              disabled={!sel || busy}
              data-testid="sample-use-alignment-btn"
              className="border border-zinc-700 hover:border-zinc-500 text-zinc-200 rounded-lg px-4 py-2 text-sm disabled:opacity-50">
              Use in Stand Out
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
